import React, {useEffect} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Header from "../components/Shop/Header";
import {loginClient} from "@cabinet-packages/redux";
import themeMaterialUI from "../settings/themeMaterialUI";
import {useDispatch, useSelector} from "react-redux";
import {isLogin} from "@cabinet-packages/helpers";
import {useHistory} from "react-router-dom";
import Button from "@material-ui/core/Button";
import {MZgroup} from "@cabinet-packages/components";

const useStylese = makeStyles((theme)=>({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
    },
    innerWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        height: '100vh',
        margin: '0 auto',
        maxWidth: '1056px',
        padding: '50px',
        paddingTop: 0,
    },
    patternImg: {
        width: '100%',
    },
}));

const AuthPage = () => {
    const classes = useStylese();
    const dispatch = useDispatch();
    const history = useHistory();
    const {stage} = useSelector(state => state.patients);

    useEffect(()=>{
        if (isLogin() && stage === 1)  history.push('/main-navigation')
    }, [history, stage]);

    useEffect(()=>{
        if (!isLogin()) dispatch(loginClient(themeMaterialUI, history, false));
    }, [dispatch, history]);

    return (
        <div className={classes.root}>
            <div className={classes.innerWrapper}>
                <Header/>
                <Button
                    color="primary"
                    variant="outlined"
                    onClick={() => dispatch(loginClient(themeMaterialUI, history, false))}
                >
                    Ввійти в особистий кабінет
                </Button>
            </div>
            <MZgroup/>
            {/*<Footer/>*/}
        </div>
    );
};

export default AuthPage;